import React from "react";
import { Card, Icon, Row, Text, Column } from "@amzn/meridian";
import chevronRightSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-right-small";
import { Question, Result } from "src/data/types";

type ObjectGroupCardProps = {
  objectType: string;
  questions: Question[];
  completedInstanceCount: number;
  onSelect: (objectType: string, questions: Question[]) => void;
};

const ObjectGroupCard = ({
  objectType,
  questions,
  completedInstanceCount,
  onSelect,
}: ObjectGroupCardProps) => {
  // Capitalize object type for display
  const displayName = objectType.charAt(0).toUpperCase() + objectType.slice(1);
  const questionCount = questions.length;
  
  return (
    <div 
      style={{ cursor: 'pointer' }}
      onClick={() => onSelect(objectType, questions)}
    >
      <Card spacingInset="none">
        <Row alignmentHorizontal="justify" spacingInset="300 400" alignmentVertical="center">
          <Column spacing="100">
            <Text>{`${displayName} (${questionCount} question${questionCount !== 1 ? 's' : ''})`}</Text>
            {completedInstanceCount > 0 && (
              <Text type="b100" color="success">
                {completedInstanceCount === 1 
                  ? `Instance #1 completed` 
                  : `${completedInstanceCount} instances completed`}
              </Text>
            )}
          </Column>
          <Icon tokens={chevronRightSmallTokens} color="primary" />
        </Row>
      </Card>
    </div>
  );
};

export default ObjectGroupCard;
